// Utility classes for detecting specific touch actions.
// This module can be moved to a separate repo.

'use strict';

module.exports = {
    MultiTouchDetector: require('./MultiTouchDetector'),
    DoubleTapDetector: require('./DoubleTapDetector'),
    PanDetector: require('./PanDetector'),
    SwipeDetector: require('./SwipeDetector'),
    PinchDetector: require('./PinchDetector'),
};
